// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3L4jm","title":"ClientReferral_title__1G9_e","itemText":"ClientReferral_itemText__VZyls"};